import script from "./GuestWalletRequestRefund.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuestWalletRequestRefund.vue?vue&type=script&setup=true&lang=ts"

import "./GuestWalletRequestRefund.vue?vue&type=style&index=0&id=1077b0e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1077b0e0"]])

export default __exports__